import { createApiCallActions } from '../../../common/store/generic.actions';
import { History } from './types';

export const historyActions = {
  getByEntityId: createApiCallActions<History[]>('history', 'getByEntityId'),
};

export type HistoryAction = typeof historyActions;
